import { Helmet } from 'react-helmet-async';

const LOCAL_BUSINESS_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  '@id': 'https://www.djmayday.com',
  name: 'DJ Mayday',
  description: 'DJ professionnel pour événements privés et publics en Wallonie — mariages, anniversaires, soirées d\'entreprise, bars et festivals.',
  url: 'https://www.djmayday.com',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Ouffet',
    addressRegion: 'Wallonie',
    postalCode: '4590',
    addressCountry: 'BE',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 50.4333,
    longitude: 5.5167,
  },
  areaServed: [
    { '@type': 'City', name: 'Liège' },
    { '@type': 'City', name: 'Ouffet' },
    { '@type': 'City', name: 'Bruxelles' },
    { '@type': 'City', name: 'Namur' },
    { '@type': 'City', name: 'Nandrin' },
    { '@type': 'City', name: 'Sprimont' },
    { '@type': 'City', name: 'Herve' },
    { '@type': 'State', name: 'Wallonie' },
    { '@type': 'Country', name: 'Belgique' },
  ],
  knowsAbout: ['DJ', 'Animation musicale', 'Mariage', 'Anniversaire', 'Événement d\'entreprise', 'Festival', 'Techno', 'House', 'Electro'],
  sameAs: [
    'https://www.facebook.com/djmaydayoff',
    'https://www.instagram.com/djmaydayoff/',
    'https://soundcloud.com/djmaydayoff',
    'https://www.youtube.com/@DJMayDayOff',
    'https://www.tiktok.com/@djmaydayoff',
  ],
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '100',
    bestRating: '100',
    worstRating: '0',
    ratingCount: '19',
  },
};

const SeoHelmet = ({
  title = 'DJ Mayday | DJ Liège & Wallonie',
  description = 'DJ Mayday — DJ professionnel pour mariages, anniversaires et soirées en Wallonie. Basé à Ouffet, il anime vos événements à Liège et dans toute la région.',
  url = 'https://www.djmayday.com/',
  image = 'https://www.djmayday.com/images/djmayday.jpg',
  noIndex = false,
}) => {
  return (
    <Helmet>
      {/* Title & Meta */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="fr_BE" />

      {/* Twitter Cards */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Structured Data */}
      {!noIndex && <script type="application/ld+json">{JSON.stringify(LOCAL_BUSINESS_SCHEMA)}</script>}
    </Helmet>
  );
};

export default SeoHelmet;
